<div class="fade-in">
	<app-breadcrumbs></app-breadcrumbs>
</div>
<nz-card>
	<ul>
		@if (isAdmin() || isClientAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'lc'])">Content Management</a>
			</li>
		}
		@if (isAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'content-generation'])">Content Generation</a>
			</li>
		}
		@if (isAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'iam'])">User Management</a>
			</li>
		}
		@if (isAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'rubrics'])">Rubrics</a>
			</li>
		}
		@if (isAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'purchases'])">Purchases &amp; Licenses</a>
			</li>
		}
		@if (isAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'products'])">Products</a>
			</li>
		}
		@if (isAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'product-status'])">Product Status</a>
			</li>
		}
		@if (isAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'media-depot'])">Media Depot</a>
			</li>
		}
		@if (isAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'setup-wizard', SetupWizardState.CLIENT_PICKER])">
					Setup Wizard
				</a>
			</li>
		}
		@if (isAdmin() || isClientAdmin() || isDistrictAdmin() || isSchoolAdmin() || isTeacher() || isDemo()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'section-enrollment'])">Section Enrollment</a>
			</li>
		}
		@if (isAdmin()) {
			<li>
				<a (click)="nav.navigate(['my', 'admin', 'stride-algorithm-report'])">Stride Algorithm Report</a>
			</li>
		}
	</ul>
</nz-card>
